/**
 * Print size format mapping for icon files
 * 
 * This file maps different variations of print format codes to their corresponding icon filenames.
 * Format codes are extracted from the format field (e.g., "C101V" from "C101V (266 x 398)")
 * 
 * Format:
 * 'format code': 'filename.svg'
 */

const printsizesMapping = {
  // C format codes
  'C101V': 'print-sizeC101V.svg',
  'CS101V': 'print-sizeCS101V.svg',
  'C102VL': 'print-sizeC102VL.svg',
  'C102VS': 'print-sizeC102VS.svg',
  'C104B': 'print-sizeC104B.svg',
  'C104BS': 'print-sizeC104BS.svg',
  'C104VL': 'print-sizeC104VL.svg',
  'C112B': 'print-sizeC112B.svg',
  
  // D format codes
  'D101V': 'print-sizeD101V.svg',
  'D101V-A': 'print-sizeD101V-A.svg',
  'D102VL': 'print-sizeD102VL.svg',
  'D102VS': 'print-sizeD102VS.svg',
  'D104B': 'print-sizeD104B.svg',
  'D104BL': 'print-sizeD104BL.svg',
  'D104BS': 'print-sizeD104BS.svg',
  'D104BS-A': 'print-sizeD104BS-A.svg',
  'D104L': 'print-sizeD104L.svg',
  'D104VL': 'print-sizeD104VL.svg',
  'D105S': 'print-sizeD105S.svg',
  'D106B': 'print-sizeD106B.svg',
  'D106L': 'print-sizeD106L.svg',
  'D106VL': 'print-sizeD106VL.svg',
  'D107L': 'print-sizeD107L.svg',
  'D108BL': 'print-sizeD108BL.svg',
  'D108BS': 'print-sizeD108BS.svg',
  'D108VL': 'print-sizeD108VL.svg',
  'D110BL': 'print-sizeD110BL.svg',
  'D112B': 'print-sizeD112B.svg',
  'D114BL': 'print-sizeD114BL.svg',
  'D114L': 'print-sizeD114L.svg',
  'D116BL': 'print-sizeD116BL.svg',
  'D116BS': 'print-sizeD116BS.svg',
  'D116L': 'print-sizeD116L.svg',
  'D120L': 'print-sizeD120L.svg',
  'D121S': 'print-sizeD121S.svg',
  'D124L': 'print-sizeD124L.svg',
  'D125L': 'print-sizeD125L.svg',
  'D127BS': 'print-sizeD127BS.svg',
  'D132BL': 'print-sizeD132BL.svg',
  'D143B': 'print-sizeD143B.svg',
  'D148BS': 'print-sizeD148BS.svg',
  'D150L': 'print-sizeD150L.svg',
  'D166L': 'print-sizeD166L.svg',
  'D205S': 'print-sizeD205S.svg',
  'D308VL': 'print-sizeD308VL.svg',
  'D316B': 'print-sizeD316B.svg',
  'D320B': 'print-sizeD320B.svg',
  'D320BS': 'print-sizeD320BS.svg',
  'D380BS': 'print-sizeD380BS.svg',
  
  // S format codes
  'S101V': 'print-sizeS101V.svg',
};

/**
 * Get the correct icon filename for a print format
 * @param {string} format - The print format to look up
 * @returns {string} The correct icon filename or null if not found in mapping
 */
export const getPrintsizeIconFilename = (format) => {
  if (!format) return 'print-placeholder.svg';
  
  // Extract the format code (e.g., "C101V" from "C101V (266 x 398)")
  const formatMatch = format.match(/^([A-Z0-9\-]+)/);
  if (!formatMatch) return 'print-placeholder.svg';
  
  const formatCode = formatMatch[1];
  
  // Check if we have a direct mapping
  if (printsizesMapping[formatCode]) {
    return printsizesMapping[formatCode];
  }
  
  // If no mapping found, generate the filename using the format code
  return `print-size${formatCode}.svg`;
};

export default printsizesMapping; 